import BaseComponent from "../../../baseComponent.js";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import DataSetService from "../../../../core/services/datasetService.js";
import styles from "./styles.scss";

export default class DatasetWithFields extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      fields: []
    }
  }

  handleClick(e) {
    var _this = this;
    this.selectedHeader = $(e.currentTarget);

    DataSetService.getDataProfileById(this.props.dataset.dataProfile, function (response) {
      var fields = response.data[0].fields;

      _this.setState({
        fields: fields
      });
    });
  }

  componentDidUpdate() {
    // toggle clicked header after render finished
    var _this = this;
    this.toggleDataFieldsBody();

    var fields = document.querySelectorAll("." + styles.field);

    for (var i = 0; i < fields.length; i++) {
      fields[i].addEventListener('dragstart', (e) => {
        var fieldIndex = $(e.target).attr("data-index");
        var data = {
          dataset: _this.props.dataset,
          field: _this.state.fields[fieldIndex],
          value: _this.props.dataset.name.replace(/([\+\-\*\/])/g, "_") + " " + _this.state.fields[fieldIndex].name
        };
        e.dataTransfer.setData("text/plain", data.dataset.name.replace(/([\+\-\*\/])/g, "_") + " " + data.field.name);
        e.dataTransfer.setData("data", JSON.stringify(data));
        this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START);
      }, false);

      fields[i].addEventListener('dragend', (e) => {
        this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END);
      }, false);
    }
  }

  componentDidMount() {
    this.refs.dataset.addEventListener('dragstart', (e) => {
      e.dataTransfer.setData("text/plain", this.props.dataset.name);
      e.dataTransfer.setData("data", JSON.stringify({
        dataset: this.props.dataset,
        isDatasetDrop: true,
        value: this.props.dataset.name.replace(/([\+\-\*\/])/g, "_")
      }));
      this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_START);
    });

    this.refs.dataset.addEventListener('dragend', (e) => {
      this.publish(InternalEvent.Dashboard.AddWidget.FIELD_DRAG_END);
    }, false);
  }

  // reset opened body when receiving new prop
  componentWillReceiveProps() {
    if (this.selectedHeader) {
      this.close(this.selectedHeader);
      this.selectedHeader = null;
    }
  }

  toggleDataFieldsBody() {
    var _this = this;
    if (this.selectedHeader) {
      if (this.selectedHeader.hasClass("activated")) {
        this.close(this.selectedHeader);
        this.selectedHeader = null;
      } else {
        var activatedHeader = this.selectedHeader.parent().siblings().children(".collapsible-header.activated");
        this.close(activatedHeader);
        this.open(this.selectedHeader, function () {
          if (_this.selectedHeader.offset().top < 0) {
            _this.selectedHeader.parents(".pageable-list").scrollTo(_this.selectedHeader);
          }
        });
      }
    }
  }

  open(element, callback) {
    $(element)
      .addClass("activated")
      .next()
      .velocity("slideDown", { duration: 500, complete: callback });
    $(element).children("i").velocity({ rotateZ: "180deg" }, { duration: 500 });
  }

  close(element) {
    $(element)
      .removeClass("activated")
      .next()
      .velocity("slideUp", { duration: 500 });
    $(element).children("i").velocity({ rotateZ: "0deg" }, { duration: 500 });
  }

  render() {
    let fields = [];

    for (let i = 0; i < this.state.fields.length; i++) {
      if (this.state.fields[i].fieldId != null) {
        fields.push(<div className={styles.field}
          draggable="true"
          data-index={i}
          key={i}>
          <div></div>
          <span>{this.state.fields[i].name}</span>
        </div>);
      }
    }

    return (
      <li className={styles.datasets}>
        <div className={["collapsible-header", styles.header].join(" ")} onClick={this.handleClick} draggable="true" ref="dataset">
          <i className="icon-arrow-up-circle"/>
          <span className={styles.datasetName}>{this.props.dataset.name}</span>
        </div>
        <div className={["collapsible-body", styles.fields].join(" ")}>
          {fields}
        </div>
      </li>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/search/datasetWithFields.jsx